import Box from 'shared_DEPRECATED/components/Box';

import { Typography } from 'shared/components/Typography';

type TChallengeInfoNameProps = {
  name: string;
  isCropped?: boolean;
  maxWidth?: string;
};

export const ChallengeInfoName = ({
  name,
  isCropped = true,
  maxWidth = '18rem',
}: TChallengeInfoNameProps) => (
  <Box
    style={{
      maxWidth,
    }}
  >
    <Typography
      as="p"
      color="black"
      fontWeight="regular"
      type="meta"
      cropped={isCropped}
      wordBreak={!isCropped ? 'break-word' : 'normal'}
      data-testid="challenge-title"
      title={name}
    >
      {name}
    </Typography>
  </Box>
);
